import "core-js/modules/es.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CallToAction } from 'components/CallToAction';
import { ACTIONS } from 'components/CallToAction/actions';
import modal, { CLOSE_SOURCES } from 'decorators/Modal/Modal';
import { decorateWith, withName } from 'helpers/decorator';
import { messages } from './UpdateProfileModal.messages';
var modalConfig = {
  hideClose: true
};
export var UpdateProfileModalUnwrapped = function UpdateProfileModalUnwrapped(_ref) {
  var missingRequirements = _ref.missingRequirements,
      onModalClose = _ref.onModalClose;
  return React.createElement("section", {
    className: "modal__body text--center"
  }, React.createElement("h2", {
    className: "mb"
  }, React.createElement(FormattedMessage, messages.heading)), React.createElement("p", {
    className: "mb"
  }, React.createElement(FormattedMessage, messages.copy)), React.createElement("ul", {
    className: "mb"
  }, missingRequirements.map(function (requirement) {
    return React.createElement("li", {
      key: requirement,
      className: "text--bold"
    }, React.createElement(FormattedMessage, messages[requirement]));
  })), React.createElement(CallToAction, {
    action: ACTIONS.LINK,
    color: "primary_solid",
    to: "/settings/contact",
    onClick: function onClick() {
      return onModalClose(CLOSE_SOURCES.ITEM_CLICK);
    }
  }, React.createElement(FormattedMessage, messages.cta)));
};
UpdateProfileModalUnwrapped.propTypes = {
  missingRequirements: PropTypes.arrayOf(PropTypes.oneOf(['address', 'dateOfBirth', 'phone', 'emergencyContact'])).isRequired,
  onModalClose: PropTypes.func.isRequired
};
export var UpdateProfileModal = decorateWith(modal(modalConfig), withName('UpdateProfileModal'))(UpdateProfileModalUnwrapped);